/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserType } from '../../models/user-type';

export interface FindById$Params {
  id_user: string;
}

export function findById(
  http: HttpClient,
  rootUrl: string,
  params: FindById$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<UserType>> {
  const rb = new RequestBuilder(rootUrl, findById.PATH, 'get');
  if (params) {
    rb.path('id_user', params.id_user, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserType>;
    })
  );
}

findById.PATH = '/v2/users/{id_user}';
